import groupModule from '../groupModule';

function groupWall(groupResources) {
    "ngInject";
    return {
        restrict: "A",
        templateUrl: groupResources.templates.groupWallTemplate
    }
};

groupModule.directive("groupWall", groupWall);

export default groupWall;